import { render, staticRenderFns } from "./Verrechnungspositionen.vue?vue&type=template&id=5b650a4a&"
import script from "./Verrechnungspositionen.vue?vue&type=script&lang=js&"
export * from "./Verrechnungspositionen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports